var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 7.33264V9.99931C1.66797 12.1992 1.66797 13.2991 2.35139 13.9826C3.0348 14.666 4.13475 14.666 6.33464 14.666H7.66797C9.86786 14.666 10.9678 14.666 11.6512 13.9826C12.3346 13.2991 12.3346 12.1992 12.3346 9.99931V7.33264",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.99935C1 5.50089 1 5.25166 1.13397 5.06602C1.22174 4.9444 1.34798 4.84341 1.5 4.7732C1.73205 4.66602 2.04359 4.66602 2.66667 4.66602H11.3333C11.9564 4.66602 12.2679 4.66602 12.5 4.7732C12.652 4.84341 12.7783 4.9444 12.866 5.06602C13 5.25166 13 5.50089 13 5.99935C13 6.49781 13 6.74704 12.866 6.93268C12.7783 7.0543 12.652 7.15529 12.5 7.2255C12.2679 7.33268 11.9564 7.33268 11.3333 7.33268H2.66667C2.04359 7.33268 1.73205 7.33268 1.5 7.2255C1.34798 7.15529 1.22174 7.0543 1.13397 6.93268C1 6.74704 1 6.49781 1 5.99935Z",
    stroke: "#DDDDEE",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.52312C3 1.86564 3.53299 1.33264 4.19048 1.33264H4.42857C5.84873 1.33264 7 2.48391 7 3.90407V4.66598H5.14286C3.95939 4.66598 3 3.70659 3 2.52312Z",
    stroke: "#DDDDEE",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.52312C11 1.86564 10.467 1.33264 9.80952 1.33264H9.57143C8.15127 1.33264 7 2.48391 7 3.90407V4.66598H8.85714C10.0406 4.66598 11 3.70659 11 2.52312Z",
    stroke: "#DDDDEE",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.33264L7 14.666",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.3c1f1d6533ccbc1bd7a444b186f302f7.svg";
export { ForwardRef as ReactComponent };